const settings = {
  namespaced: true,
  state: {
    language: process.env.VUE_APP_LANG,
    defaultLanguage: process.env.VUE_APP_LANG,
  },
  getters: {
    getLanguage: (state) => {
      return state.language
    },
    getDefaultLanguage: (state) => {
      return state.defaultLanguage
    },
  },
  actions: {
    updateLanguage({ commit }, lang) {
      commit('updateLanguage', lang)
    },
  },
  mutations: {
    updateLanguage(state, lang) {
      state.language = lang
    },
  },
}

export default settings
